import { useAtomValue, useSetAtom } from "jotai"
import React, { useEffect, useRef } from "react"
import { ModalForm } from "@ant-design/pro-form"
import { Button } from "antd"
import { DeleteOutlined } from "@ant-design/icons"
import axiosApiInstance from "../../../../api/axiosClient"
import { useNavigate, useParams } from "react-router-dom"
import { ActionType } from "@ant-design/pro-table"
import { queryClientAtom } from "jotai-tanstack-query"

const REDIRECT_URL = `/music/labels/`

const DeleteLabelForm = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const queryClient = useAtomValue(queryClientAtom)

  return (
    <ModalForm
      open
      width={400}
      title={`Delete Label: ${id}`}
      submitter={{ submitButtonProps: { danger: true } }}
      autoFocusFirstInput
      modalProps={{
        destroyOnClose: true,
        okText: "Delete",
        cancelText: "No",
        onCancel: () => navigate(REDIRECT_URL),
      }}
      onFinish={async (values) => {
        return axiosApiInstance
          .delete(`/api/products/labels/${id}`)
          .then((res) => {
            // console.log(res)
            // queryClient.invalidateQueries({queryKey: ['creators','items']})
            // actionRef?.current?.reload();
            queryClient.invalidateQueries({ queryKey: ["labels"] })
            navigate(REDIRECT_URL)
            return true
          })
          .catch((reason) => {
            console.log(reason)
          })
      }}
    >
      Are you sure?
    </ModalForm>
  )
}

export default DeleteLabelForm
